import { render, staticRenderFns } from "./BaseChips.vue?vue&type=template&id=0bd705a0&scoped=true"
import script from "./BaseChips.vue?vue&type=script&lang=js"
export * from "./BaseChips.vue?vue&type=script&lang=js"
import style0 from "./BaseChips.vue?vue&type=style&index=0&id=0bd705a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd705a0",
  null
  
)

export default component.exports